<template>
  <!-- Page Content -->
  <div id='page-wrapper'>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='row'>
        <div class='col-lg-12'>
          <h1 class='page-header'>حركة المستخدمين</h1>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <!-- /.row -->
      <div class='row'>
        <div class='col-lg-12'>
          <div class='panel panel-default'>
            <div class='panel-heading'>
      هنا يتم عرض جميع حركات المستخدمين حسب الفرع والمستخدم والتاريخ
            </div>
            <!-- /.panel-heading -->
            <div class='panel-body'>
              <div class='alert alert-danger alert-dismissable' v-if='validationErrors'>
                <ul v-if='validationErrors'>
                    <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                </ul>
              </div>
              <div class='col-lg-12' style="margin:0px;padding:0px">
                <div class='col-lg-2 col-md-2 col-sm-6' style="padding: 5px 5px">
                      <label>الفرع</label>
                      <select  @change='changeBranche()' class="form-control"  v-model="branch_id">
                        <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                          {{ item.name }}
                        </option>
                      </select>
                </div>
                <div class='col-lg-5 col-md-5 col-sm-6' style="padding: 5px 5px">
                  <div class="col-lg-10 col-md-10 col-sm-10" style="padding: 0px 15px 0px 0px">
                    <label>المستخدم</label>
                    <select class="form-control"  v-model="emp_id">
                      <option v-for="item in emp" v-bind:key="item.id" v-bind:value="item.id">
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                      <div class="col-lg-2 col-md-2 col-sm-2" style="padding: 25px 0px 0px 0px">
                        <button  @click='getActiveEmp()' type="button" class="btn btn-default"><i class="fa fa-user"></i></button>
                      </div>
                </div>
                <div class='col-lg-2 col-md-2 col-sm-6' style="padding: 5px 5px">
                  <tbDate  :mytitle='fromTitle' v-model= 'date_from' ></tbDate>
                </div>
                <div class='col-lg-2 col-md-2 col-sm-6' style="padding: 5px 5px">
                  <tbDate  :mytitle='toTitle' v-model= 'date_to' ></tbDate>
                </div>
                <div class='col-lg-1 col-md-1 col-sm-12' style="padding: 28px 0px 15px 0px; text-align: center;">
                  <button @click='GetData()' type='button'  class='btn btn-outline btn-primary btn-md'>
                    <b>عرض</b>
                  </button>
                </div>
              </div>
              <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                  <thead>
                    <tr>

                        <th style='text-align: center'>م</th>
                        <th style='text-align: center'>القسم</th>
                        <th style='text-align: center'>الحركة</th>
                        <th style='text-align: center'>رقم السجل</th>
                        <th style='text-align: center'>التاريخ</th>
                        <th style='text-align: center'>الوقت</th>
                        <th style='text-align: center'>الاجراء</th>
                    </tr>
                  </thead>
                  <tbody>
                      <tr class='odd gradeX' v-for='(record,index) in records' :key='record.id'>

                        <td align='center'>{{index +1}}</td>
                        <td align='center'>{{record.log_name}}</td>
                        <td align='center'>{{record.description}}</td>
                        <td align='center'>{{record.subject_id}}</td>
                        <td align='center'>{{record.Ac_date}}</td>
                        <td align='center'>{{record.Ac_time}}</td>
                        <td align='center'>
                            <vue-element-loading size='32' :active='isLoadingDelete' spinner='bar-fade-scale' color='#A4A4A4'/>
                            <button @click='showForm(record)' type='button' class='btn btn-outline btn-info btn-xs' data-toggle='modal' data-target='#myModal'>عرض</button>
                          </td>
                      </tr>
                  </tbody>
              </table>
              <!-- /.table-responsive -->
            </div>
            <!-- /.panel-body -->
          </div>
          <!-- /.panel -->
        </div>
        <!-- /.col-lg-12 -->
      </div>
    </div>
    <!-- Modal -->
    <div class='modal fade' id='myModal' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
        <div class='modal-dialog  modal-lg'>
            <div class='modal-content'>
                <div class='modal-header'>
                    <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
                    <h4 class='modal-title' id='myModalLabel'>عرض حركة مستخدم</h4>
                </div>
                <form role='form'>
                <div class='modal-body'>
                  <fieldset>
                        <div class='form-group col-lg-6 col-sm-6'>
                          <label>قبل العملية</label>
                          <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                              <thead>
                                <tr>
                                  <th style='text-align: center;padding:2px'>القيمة</th>
                                  <th style='text-align: center;padding:2px'>الحقل</th>
                                </tr>
                              </thead>
                              <tbody>
                                  <tr class='odd gradeX' v-for='(value, key,index) in before' :key='index'>
                                    <td  style='text-align: center;padding:2px' align='center'>{{value}}</td>
                                    <td  style='text-align: center;padding:2px' align='center'>{{key}}</td>
                                  </tr>
                              </tbody>
                          </table>
                        </div>
                        <div class='form-group col-lg-6 col-sm-6'>
                          <label>بعد العملية</label>
                          <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                              <thead>
                                <tr>
                                  <th style='text-align: center;padding:2px'>القيمة</th>
                                  <th style='text-align: center;padding:2px'>الحقل</th>
                                </tr>
                              </thead>
                              <tbody>
                                  <tr class='odd gradeX' v-for='(value, key,index) in after' :key='index'>
                                    <td  style='text-align: center;padding:2px' align='center'>{{value}}</td>
                                    <td  style='text-align: center;padding:2px' align='center'>{{key}}</td>
                                  </tr>
                              </tbody>
                          </table>
                        </div>
                        <div class='form-group col-lg-12 col-sm-12'>
                          <label>التغيير</label>
                          <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                              <thead>
                                <tr>
                                  <th style='text-align: center;padding:2px'>القيمة</th>
                                  <th style='text-align: center;padding:2px'>الحقل</th>
                                </tr>
                              </thead>
                              <tbody>
                                  <tr class='odd gradeX' v-for='(value, key,index) in changes' :key='index'>
                                    <td  style='text-align: center;padding:2px' align='center'>{{value}}</td>
                                    <td  style='text-align: center;padding:2px' align='center'>{{key}}</td>
                                  </tr>
                              </tbody>
                          </table>
                        </div>
                      </fieldset>
                  </div>
                  <div class='modal-footer'>
                      <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
                  </div>
                </form>
            </div>
            <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <!-- /.container-fluid -->
  </div>
</template>
<style>
.highlight {
   background-color: #5A9EF5;
}
tr:hover{
   cursor: pointer;
}
</style>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
export default {
  components: {
    tbDate
  },
  name: 'return_purchase_masters',
  data () {
    return {
      fromTitle: 'من',
      toTitle: 'إلى',
      date_from: '',
      date_to: '',
      branches: {},
      emp: {},
      emp_id: '',
      branch_id: '',
      after: '',
      before: '',
      changes: {},
      validationErrors: '',
      records: {},
      record: {},
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      isLoadingDelete: false,
      isLoadingDeleteItem: false
    }
  },
  created () {
    var today = new Date()
    var dd = String(today.getDate()).padStart(2, '0')
    var mm = String(today.getMonth() + 1).padStart(2, '0')
    var yyyy = today.getFullYear()
    today = dd + '-' + mm + '-' + yyyy
    this.date_from = today
    this.date_to = today
    this.branches = JSON.parse(localStorage.getItem('Branches'))
  },
  methods: {
    getActiveEmp () {
      this.isLoadingData = true
      this.validationErrors = ''
      axios.post(this.$apiURL + 'getActiveEmp', {
        token: localStorage.getItem('token'),
        branch_id: this.branch_id
      })
        .then(({ data }) => {
          this.emp = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          this.validationErrors = err.response.data.errors
          this.isLoadingData = false
        })
    },
    changeBranche () {
      this.isLoadingData = true
      this.validationErrors = ''
      axios.post(this.$apiURL + 'getBranchActivityUsers', {
        token: localStorage.getItem('token'),
        branch_id: this.branch_id
      })
        .then(({ data }) => {
          this.emp = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          this.validationErrors = err.response.data.errors
          this.isLoadingData = false
        })
    },
    GetData () {
      this.isLoadingData = true
      this.validationErrors = ''
      axios.post(this.$apiURL + 'getBranchUsersActivity', {
        token: localStorage.getItem('token'),
        emp_id: this.emp_id,
        date_from: this.date_from,
        date_to: this.date_to
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          this.validationErrors = err.response.data.errors
          this.isLoadingData = false
        })
    },
    showForm (recID) {
      this.after = recID.properties.attributes
      this.before = recID.properties.old
      this.changes = {}
      if (this.before != null && this.before.length !== 0 && this.after != null && this.after.length !== 0) {
        let IsFound = false
        for (let [key, value] of Object.entries(recID.properties.attributes)) {
          IsFound = false
          for (let [key1, value1] of Object.entries(recID.properties.old)) {
            if (key === key1 && value === value1) {
              IsFound = true
            }
          }
          if (IsFound === false) {
            this.changes[key] = value
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Settings/UsersActivity.vue